/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ViewNoteDialog/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import DeleteAction from './DeleteAction/index'
import EditAction from './EditAction/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import NoteHistory from './NoteHistory/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ViewNoteDialog({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note/ViewNoteDialog",
  isOpen,
  contentRef,
  left,
  top,
  onMouseEnter,
  onMouseLeave,
  onEdit
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventContentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'content',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={isOpen}>
<div
  data-testid="ViewNoteDialog.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--l-1-rk6B9': typeof left === 'number' ? `${left}px` : left,'--t-2-rk6B9': typeof top === 'number' ? `${top}px` : top,'--btlr-3-rk6B9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-rk6B9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-5-rk6B9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-6-rk6B9': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-7-rk6B9': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-8-rk6B9': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-9-rk6B9': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-10-rk6B9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-rk6B9': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.content"
 text={eventContentValueData}
 weight="regular"
 size="normal"
/>
<NoteHistory
  viewPath={`${viewPath}/NoteHistory`}
/>
<div
  data-testid="ViewNoteDialog.Horizontal"
  data-view-path={viewPath}
 style={{'--g-7-rk6B9': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<EditAction
  viewPath={`${viewPath}/EditAction`}
 onEdit={onEdit}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
</div>
</fromFlow.When>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}